import React from 'react';

import circlePlusUrl from '../assets/circle-plus.svg';
import editUrl from '../assets/edit.svg';
import infoUrl from '../assets/info.svg';
import refreshUrl from '../assets/refresh.svg';
import retireDisabledUrl from '../assets/retire-disabled.svg';
import retireUrl from '../assets/retire.svg';

const ICONS = {
    addRole: { src: circlePlusUrl, size: 20 },
    edit: { src: editUrl, size: 20 },
    info: { src: infoUrl, size: 15 },
    refresh: { src: refreshUrl, size: 20 },
    retire: { src: retireUrl, disabledSrc: retireDisabledUrl, size: 20 }
};

/** Decorative design asset; the adjacent button or banner text supplies its name. */
const ActionIcon = ({ name, disabled = false }) => {
    const icon = ICONS[name];
    if (!icon) return null;
    const src = disabled && icon.disabledSrc ? icon.disabledSrc : icon.src;
    return <img src={src} alt="" width={icon.size} height={icon.size} className="action-asset-icon" />;
};

export default ActionIcon;
